import styled from "styled-components";

export const StyledManageCMSheet = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
